export const FETCH_AGENT_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_meta_fields`;
export const CREATE_AGENT_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_meta_fields/create`;
export const UPDATE_AGENT_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_meta_fields`;
export const DELETE_AGENT_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/agents_meta_fields`;
export const UPDATE_AGENT_META_FIELD_BY_AGENT_CUSTOM_URL = `${process.env.REACT_APP_API_URL}/agents_meta_fields`;
